import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentService } from '../../../../../core/services/payment.service';

@Component({
  selector: 'app-payment-creditcard-complete',
  templateUrl: './payment-creditcard-complete.component.html',
  styleUrls: ['./payment-creditcard-complete.component.scss']
})
export class PaymentCreditcardCompleteComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private paymentService: PaymentService) {
    this.activatedRoute.queryParamMap.subscribe(params => {
      console.log(params);
      this.trackerId = params.get('trackerID') || '';
      console.log("completion trackerid=" + this.trackerId);
    }
    );
  }
  trackerId: string = '';
  ngOnInit() {
    this.completeTxn();
  }

  async completeTxn() {
    //this.trackerId = localStorage.getItem("trkId");// this.route.snapshot.paramMap.get("trackerId");
    /////this.trackerId = await this.getParamValueQueryString();
    if (this.trackerId) {
      var request = { "trackerId": this.trackerId, "token": "" };
      try {
        var paymentResponse = await this.paymentService.completeCreditCardPayment(request).toPromise();
      }
      catch (e) {

      }
      //alert(paymentResponse.message);
      this.router.navigate(['/invoice-inquiry/payment/review']);
    } else {
      //alert("Invalid Request");
      this.router.navigate(['/invoice-inquiry/payment/review']);
    }
  }
  //async backToReview() {
  //  this.router.navigate(['/invoice-inquiry/payment/review']);
  //}
  //async getParamValueQueryString() {
  //  let paramValue;
  //  const url = window.location.href;
  //  if (url.includes('?')) {
  //    const httParams = new HttpParams({ fromString: url.split('?')[1] });
  //    paramValue = httParams.get('TrackerId');
  //  }
  //  return paramValue;
  //}
}
